/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CreditUpsertMutation($customerId: ID!, $limit: Float!) {
  CreditUpsert(customerId: $customerId, limit: $limit) {
    id,
    message
    status
  }
}
`
